import * as React from 'react';
import * as ResizablePrimitive from 'react-resizable-panels';

import { cn } from '@/lib/utils';

function ResizablePanelGroup({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
  return (
    <ResizablePrimitive.PanelGroup
      data-slot="resizable-panel-group"
      className={cn(
        'flex h-full w-full data-[panel-group-direction=vertical]:flex-col',
        className,
      )}
      {...props}
    />
  );
}

function ResizablePanel({
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
  return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
  withHandle,
  className,
  style,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <ResizablePrimitive.PanelResizeHandle
      data-slot="resizable-handle"
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        zIndex: 10,
        // Default horizontal handle
        cursor: 'col-resize',
        width: '6px',
        // These will be overridden by CSS for vertical handles
        ...style,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cn(
        // CSS for handling vertical vs horizontal orientation
        'resizable-handle group',
        '[&[data-panel-group-direction=vertical]]:cursor-row-resize',
        '[&[data-panel-group-direction=vertical]]:h-2',
        '[&[data-panel-group-direction=vertical]]:w-full',
        className,
      )}
      {...props}
    >
      {withHandle && (
        <div
          style={{
            backgroundColor: isHovered ? '#d0d0d0' : 'transparent',
            zIndex: 10,
            height: '40px',
            width: '6px',
            borderRadius: '3px',
            transition: 'all 0.15s ease-in-out',
            opacity: isHovered ? 1 : 0,
          }}
        />
      )}
    </ResizablePrimitive.PanelResizeHandle>
  );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
